import React, { useEffect, useRef, useState } from 'react';
import { usePurchaseRequestApi } from '../../../store/api/hooks/purchaseApiHook';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Drawer from '../../../components/Drawer';
import Button from '../../../components/elements/button';
import { Dropdown, Menu } from '../../../components/Dropdown';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import Icon from '../../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import Loader from '../../../components/loader';
import { PAGE_SIZE } from '../../../_common/constant';
import { StatusStaticPRCell, titleCell } from '../../../components/elements/function';
import { downloadExcel, downloadPDF, getPermissionInfo, showLocalDate } from '../../../_common/functions';
import toast from 'react-hot-toast';
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import CreatePurchaseRequest from './_components/createPurchaserequest';
import ViewPurchaseRequest from './_components/viewPurchaseRequested';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useSpearPartsApi } from '../../../store/api/hooks/spearPartsApiHook';
import { usePurchaseOrderApi } from '../../../store/api/hooks/purchaseOrderApiHook';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserSelector } from '../../../store/selectors/userSelector';
import TitleCell from '../../../components/titleCell';

const PurchaseRequest: React.FC = () => {
    const prAPI = usePurchaseRequestApi();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [rowData, setrowData] = useState<any>(null);
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);
    const [selectedPRid, setSelectedPRid] = useState<any>(null);
    const [includeClosedPR, setIncludeClosedPR] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('purchaseRequestFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('purchaseRequestFilters', JSON.stringify(filters));
        }
    }, [filters]);
    const [viewMode, setViewMode] = useState<'view' | 'approve' | 'convert-po'>('view');
    const filtersRef: any = useRef();
    const { confirm } = useDialog();
    const createprRef = useRef<any>(null);
    const viewprRef = useRef<any>(null);
    const commonApi: any = useCommonApi();
    const spearPartsAPI = useSpearPartsApi();
    const POApi = usePurchaseOrderApi();
    const location = useLocation();
    const navigate = useNavigate();
    const loggedinuser: any = useUserSelector();

    const [purchaseRequestTypeOptions, setPurchaseRequestTypeOptions] = useState<any[]>([]);
    const [purchaseRequestStatusOptions, setPurchaseRequestStatusOptions] = useState<any[]>([]);
    const [showLoader, setShowLoader] = React.useState<boolean>(false);
    const purchaseApi = usePurchaseRequestApi();


    const getUserList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            commonApi.GetUserList(payload, (resp: any) => {
                resolve(resp.userList ? resp.userList.map((user: any) => {
                    return {
                        label: user.firstName + " " + user.lastName,
                        value: user.userID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    }

    const getSpearPartsList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            spearPartsAPI.getSpearPartsList(payload, (resp: any) => {
                resolve(resp.sparePartsList ? resp.sparePartsList.map((part: any) => {
                    return {
                        label: part.sparePartsName,
                        value: part.partsID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    };


    const filterConfig: filterConfigType[] = [
        { name: 'Request Type', type: 'dropdown', key: 'purchaseRequestTypeIDs', options: purchaseRequestTypeOptions },
        { name: 'Items', type: 'dropdown', key: 'partIDs', async: getSpearPartsList as any },
        { name: 'Request By', type: 'dropdown', key: 'requesterIDs', async: getUserList as any },
        { name: 'Requested Start Date', type: 'date', key: 'addedStartDate' },
        { name: 'Requested End Date', type: 'date', key: 'addedEndDate' },
        { name: 'Required by', type: 'date-range', key: 'requiredByStartDate,requiredByEndDate' },
        { name: 'Approved by', type: 'dropdown', key: 'approverIDs', async: getUserList as any },
        { name: 'Approval Start Date', type: 'date', key: 'approvalStartDate' },
        { name: 'Approval End Date', type: 'date', key: 'approvalEndDate' },
        { name: 'Status', type: 'dropdown', key: 'purchaseRequestStatusIDs', options: purchaseRequestStatusOptions },
        { name: 'Purchase Request Number', type: 'text', key: 'purchaseRequestCode' },
    ]


    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, pinned: "left",
            width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Request ID',
            field: 'purchaseRequestCode',
            headerClass: 'bg-[#f0f0f0]',
            pinned: "left",
            minWidth: 200,
            cellRenderer: (params: any) => {
                return (
                    <p
                        className='hover:text-primary font-semibold cursor-pointer'
                        title={params.value}
                        onClick={() => {
                            // Call your functions here
                            setSelectedPRid(params.data.purchaseRequestID);
                            setViewMode('view');
                            viewprRef.current?.open();
                        }}
                    >
                        {params.value}
                    </p>
                );
            }
        },
        {
            headerName: 'Location', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', pinned: "left",minWidth: 160,
            cellRenderer: titleCell
        },
        {
            headerName: 'Request Date', field: 'addedDate', headerClass: 'bg-[#f0f0f0]', pinned: "left", width: 140, cellRenderer: (data: any) => (
                <p className='hover:text-primary'>{showLocalDate(data.value)}</p>
            )
        },
        { headerName: 'Status', field: 'purchaseRequestStatusName', headerClass: 'bg-[#f0f0f0]', pinned: "left", minWidth: 210, cellRenderer: StatusStaticPRCell },
        { headerName: 'Requested By', field: 'requesterName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: titleCell },
        {
            headerName: 'Required By', field: 'requiredByDate', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 140, cellRenderer: (data: any) => (
                <p className='hover:text-primary'>{showLocalDate(data.value)}</p>
            )
        },
        { headerName: 'Items', field: 'sparePartNames', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 250, cellRenderer: (params:any)=>{
            
            const value = (params.data.purchaseRequestTypeID == 1 ? params.data.sparePartNames : params.data.assetNames ) || '';
            const values:any = value ? value.split(',') : ['--'];
            const more:number = values.length - 1;

            return <div className='text-ellipsis overflow-hidden' title={`${value}`}>{values[0]} {more > 0 ? <span className='-mt-1 badge badge-secondary px-1 text-[0.6rem]'> +{more}</span> : ''}</div>
        } },
        { headerName: 'Approved By', field: 'approverName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: titleCell },
        {
            headerName: 'Approval Date', field: 'approvedDate', headerClass: 'bg-[#f0f0f0]', width: 190,
            cellRenderer: (data: any) => (
                <p className='hover:text-primary font-semibold cursor-pointer'>{showLocalDate(data.value)}</p>
            )
        },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,
            pinned: "right",
            cellRenderer: (params: any) => {
                const statusID = params?.data?.purchaseRequestStatusID;
                const isPOCreated = params?.data?.isPOCreated;

                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' />
                        <select
                            onChange={(e) => {
                                /* const action = e.target.value;

                                if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
                                    toast.error(`You don't have ${action} permission`);
                                    e.target.selectedIndex = -1;
                                    return;
                                } */

                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            {([1, 2].includes(statusID) && !isPOCreated) && <option value="edit" disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)}>Edit</option>}
                            {[1, 2].includes(statusID) && <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>}
                            <option value="view">View</option>
                            {statusID === 2 && <option value="approve" disabled={!getPermissionInfo(location.pathname, "Approve PR", loggedinuser)}>Approve</option>}
                            {statusID === 3 && <option value="convert-po" disabled={!getPermissionInfo(location.pathname, "Convert PO", loggedinuser)}>Convert to PO</option>}
                            {([1].includes(statusID) && !isPOCreated) && <option value="send-for-approval">Send for Approval</option>}
                            {/*([1, 2, 3, 4].includes(statusID) && !isPOCreated) && <option value="send-for-approval">Send for Approval</option>*/}
                        </select>
                    </div>
                );
            }
        }
    ];




    const getPurchaseTypeList = () => {
        prAPI.GetPurchaseRequestTypeList({}, (resp: any) => {
            setPurchaseRequestTypeOptions(resp.purchaseRequestTypeList.map((item: any) => ({
                ...item,
                label: item.prTypeName,
                value: item.prTypeID
            })));
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };
    const getPurchaseStatusList = () => {
        prAPI.GetPurchaseRequestStatusList({}, (resp: any) => {
            console.log("Purchase Request Type List =>", resp.purchaseRequestStatusList);
            setPurchaseRequestStatusOptions(resp.purchaseRequestStatusList.map((item: any) => ({
                ...item,
                label: item.statusName,
                value: item.statusID
            })));
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };



    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        // Check permissions for specific actions
        /* if ((action === "edit" || action === "delete") && !getPermissionInfo(location.pathname, action, loggedinuser)) {
            toast.error(`You don't have ${action} permission`);
            return;
        } */

        switch (action) {
            case "edit":
                setSelectedPRid(rowData.purchaseRequestID);
                createprRef.current?.open();
                break;
            case "delete":
                confirm({
                    type: 'delete',
                    title: 'Delete Purchase Request',
                    message: 'Are you sure you want to delete this purchase request?',
                    onConfirm: () => {
                        prAPI.DeletePurchaseRequest({ PurchaseRequestID: rowData.purchaseRequestID }, (data: any, msg: any) => {
                            toast.success(msg);
                            GetPurchaseRequestList();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;
            case "view":
                setSelectedPRid(rowData.purchaseRequestID);
                setViewMode('view');
                viewprRef.current?.open();
                break;

            case "approve":
                setSelectedPRid(rowData.purchaseRequestID);
                setViewMode('approve');
                viewprRef.current?.open();
                break;
            case "convert-po":
                confirm({
                    type: 'warn',
                    title: 'Convert to Purchase Order',
                    message: 'Are you sure you want to convert this purchase request to a purchase order?',
                    onConfirm: () => {
                        /* New work */
                        setSelectedPRid(rowData.purchaseRequestID);
                        setViewMode('convert-po');
                        viewprRef.current?.open();
                        

                        /* Old work */
                        /*
                        POApi.SavePurchaseOrderFromPR({ purchaseRequestID: rowData.purchaseRequestID }, (data: any, msg: any) => {
                            toast.success(msg);
                            GetPurchaseRequestList();
                        }, (error: any) => {
                            toast.error(error);
                        });
                        */
                    }
                });
                break;
            case "send-for-approval":
                confirm({
                    type: 'warn',
                    title: 'Send for Approval',
                    message: 'Are you sure you want to send this purchase request for approval?',
                    onConfirm: () => {
                        getPurchaseRequestDetails(rowData.purchaseRequestID);
                    }
                });
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    ///


    const getPurchaseRequestDetails = async (selectedPRid: number) => {
        try {
            setShowLoader(true);
            const prdetails = await new Promise<any>((resolve, reject) => {
                purchaseApi.GetPurchaseRequestById(
                    { PurchaseRequestID: selectedPRid },
                    (resp: any) => {
                        if (resp && resp.hasOwnProperty('purchaseRequestID') && +resp.purchaseRequestID > 0) {
                            resolve(resp);
                        } else {
                            toast.error(`Failed to fetch Purchase Request details!`);
                            setShowLoader(false);
                            reject(null);
                        }
                    },
                    (error: any) => {
                        toast.error(error);
                        setShowLoader(false);
                        reject(null);
                    }
                );
            });

            const payload = {
                purchaseRequestID: prdetails.purchaseRequestID ?? 0,
                purchaseRequestCode: prdetails.purchaseRequestCode ?? "",
                facilityID: prdetails.facilityID ?? 0,
                subFacilityID: prdetails.subFacilityID ?? 0,
                purchaseRequestTypeID: prdetails.purchaseRequestTypeID ?? 0,
                purchaseRequestStatusID: 2,
                requesterID: prdetails.requesterID ?? 0,
                requiredByDate: prdetails.requiredByDate ?? new Date().toISOString(),
                notes: prdetails.notes ?? "",
                reason: prdetails.reason ?? "",
                purchaseRequestDetails: (prdetails.purchaseRequestItemList || []).map((item: any) => ({
                    partsID: item.partsID ?? 0,
                    vendorID: item.vendorID ?? 0,
                    requiredQty: item.requiredQty ?? 0,
                    unitID: item.unitID ?? 0,
                    totalAmount: item.totalAmount ?? 0
                })),
                purchaseRequestWorkOrder: (prdetails.purchaseWO || []).map((wo: any) => ({
                    workOrderID: wo.workOrderID ?? 0
                })),
                potentialAsset: (prdetails.purchaseAsset || []).map((asset: any) => ({
                    assetName: asset.assetName ?? "",
                    vendorID: asset.vendorID ?? 0,
                    unitID: asset.unitID ?? 0,
                    requiredQty: asset.requiredQty ?? 0
                }))
            };

            await new Promise((resolve, reject) => {
                purchaseApi.SavePurchaseRequest(payload, (resp: any) => {
                    resolve(resp);
                    toast.success(resp.message);
                    GetPurchaseRequestList();
                    setShowLoader(false);
                }, (error: any) => {
                    console.log("error", error);
                    toast.error(error);
                    setShowLoader(false);
                    reject(error);
                });
            }).catch((error: any) => {
                setShowLoader(false);
                return null;
            });

        } catch (error) {
            console.log("error", error);
            return null;
        }
    };




    ///

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkExportPdf = () => {
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have Export permission");
            return;
        }

        const selectedData = getSelectedRows();
        const payload: any = { };
        if (selectedData.length > 0) {
            const purchaseRequestIDs = selectedData.map((asset: any) => asset.purchaseRequestID).join(',');
            payload.purchaseRequestIDs = purchaseRequestIDs;
        }
        prAPI.ExportPurchaseRequest(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'Purchase_Request')
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
    
    const onBulkExportCsv = async () => {
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have Export permission");
            return;
        }

        const selectedData = getSelectedRows();
        const payload: any = { };
        if (selectedData.length > 0) {
            const purchaseRequestIDs = selectedData.map((asset: any) => asset.purchaseRequestID).join(',');
            payload.purchaseRequestIDs = purchaseRequestIDs;
        }
        prAPI.ExportPurchaseRequestXLS(
            payload,
            (resp: any) => { downloadExcel(resp, 'Purchase_Request') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
    const GetPurchaseRequestList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
            purchaseRequestStatusIDs: includeClosedPR ? '1,2,3,4,5,6,7,8' : '1,2,3,4,5,7',
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        setrowData(null);
        prAPI.GetPurchaseRequestList(payload, (resp: any) => {
            setrowData(resp.purchaseRequestList ? resp.purchaseRequestList : []);
            setTotalRecords(resp.totalRecord);

        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };

    useEffect(() => {
        getPurchaseTypeList();
        getPurchaseStatusList();
    }, []);

    // Call GetPurchaseRequestList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            GetPurchaseRequestList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (filtersInitialized) {
            GetPurchaseRequestList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
            locationFilter: false,
        });
    }, [currentPage, searchParam, filters, includeClosedPR]);



    // Handle opening PR from URL query params
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const openID = searchParams.get('open');
        if (openID && !isNaN(Number(openID))) {
            setSelectedPRid(Number(openID));
            setViewMode('view');
            viewprRef.current?.open();
        }
    }, [location.search]);

    return (
        <Layout>
            <Header title='Purchase Request'>
                <Header.Right>
                    <Drawer _ref={createprRef} isAfterOpenRender={true} onClose={() => {
                        setSelectedPRid(null);
                    }}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, "Add", loggedinuser)}>Add New Purchase Request</Button>
                        </Drawer.Button>
                        <Drawer.Content title='New Purchase Request' className='!w-[60rem] !pr-0'>
                            {!getPermissionInfo(location.pathname, "Add", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don't have permission to access this form.
                                </div>
                            ) : (
                                <CreatePurchaseRequest PrID={selectedPRid} onCreate={() => {
                                    createprRef.current?.close();
                                    setSelectedPRid(null);
                                    GetPurchaseRequestList();
                                }} onCancel={() => {
                                    setSelectedPRid(null);
                                    createprRef.current?.close();
                                }} />
                            )}
                        </Drawer.Content>
                    </Drawer>
                    <Drawer _ref={viewprRef} isAfterOpenRender={true} onClose={() => setSelectedPRid(null)}>
                        <Drawer.Button>
                            <div style={{ display: 'none' }}></div>
                        </Drawer.Button>
                        <Drawer.Content title={(() => {
                            switch (viewMode) {                                                            
                                case `approve`:
                                    return "Approve Purchase Request";
                                case `convert-po`:
                                    return "Convert Purchase Request to Purchase Order";
                                case `view`:
                                default:
                                    return "View Purchase Request";
                            }
                        })()} className='!w-[55rem] !pr-0'>
                            <ViewPurchaseRequest PrID={selectedPRid} mode={viewMode} onCreate={() => {
                                viewprRef.current?.close();
                                setSelectedPRid(null);
                                GetPurchaseRequestList();
                            }} onCancel={(open: string | null = null) => {
                                viewprRef.current?.close();
                                if (open == 'convert-po') { setViewMode('convert-po'); viewprRef.current?.open(); } else { setSelectedPRid(null); GetPurchaseRequestList(); }
                            }} />
                        </Drawer.Content>
                    </Drawer>

                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Purchase Request'>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>

            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                {/* <Search onSearch={setSearchParam} /> */}
            </div>

            <div className='bg-[#FAFAFA]'>
                <div className='flex justify-between px-5 py-2 items-center'>
                    <div className='flex gap-4 px-5 py-2 items-center'>
                        <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                            Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                        </Button>
                        <Dropdown>
                            <Dropdown.Button>
                                <Button theme='light'>
                                    <Icon name='grlocation' size={1.20} className={filtersApplied.locationFilter ? "text-blue-700" : ""} /> Location <Icon name='arrowdown' size={1.10} />
                                </Button>
                            </Dropdown.Button>
                        </Dropdown>
                        <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                            setFilters({});
                            localStorage.removeItem('purchaseRequestFilters');
                            setFiltersApplied({ generalFilter: false, locationFilter: false });
                            setCurrentPage(1);
                        }}>
                            Clear Filters
                        </p>
                    </div>

                    <div className='border border-primary rounded-md overflow-hidden flex'>
                        <Button
                            theme={includeClosedPR ? 'blue' : 'light'}
                            className='!rounded-none !border-0 px-3'
                            onClick={() => {
                                setIncludeClosedPR(prev => {
                                    const newVal = !prev;
                                    setCurrentPage(1);
                                    return newVal;
                                });
                            }}
                        >
                            Include Closed PR
                        </Button>
                    </div>
                </div>

                <div className="ag-theme-alpine mx-4 h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData || []}
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default PurchaseRequest;
